import FreeSubscriptionPromoBanner from './FreeSubscriptionPromoBanner';

export default FreeSubscriptionPromoBanner;
